import { registerPlugin } from '@capacitor/core';

const androidAppNotifPermissionStatusPlugin = registerPlugin('AppNotificationPermissionStatus');

export default androidAppNotifPermissionStatusPlugin;
